import { IntlTFunc } from 'next-intl';

import { CategoryTree } from '@/fo/api/magento';
import { Banner } from '@/fo/ui/kit/banner/hero';
import { staticMediaUrl } from '@/fo/util/image-loader';

const stripHtml = (value: string) =>
  value
    .replace(/\{sup\}/gi, '')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export const mapBannerHero = (
  category: CategoryTree,
  t: IntlTFunc,
  productsCount: number,
  seoH1?: string | null
) => {
  const banner = category?.category_banners?.top_banners.filter(
    (item) => item?.entity.banner_data.pdp_position === 'TOP'
  )[0];

  const title = seoH1 || category.h1 || category.name || undefined;

  if (!banner) {
    return {
      image: {
        sm: staticMediaUrl('catalog/catalog_placeholder_sm.png'),
        md: staticMediaUrl('catalog/catalog_placeholder.png')
      },
      alt: title ? stripHtml(title) : undefined,
      title,
      promotionName: title ?? undefined,
      buttonText: '',
      link: '',
      subtitle: `${productsCount} ${t('pluralizeProduct', { count: productsCount })}`,
      mode: 'light' as const
    };
  }

  const result: Banner = {
    image: {
      sm: banner.entity.banner_data?.mobile_image || '',
      md: banner.entity.banner_data?.desktop_image || ''
    },
    alt: title ? stripHtml(title) : undefined,
    title,
    promotionName:
      title ??
      (stripHtml(banner.entity.banner_data?.large_text ?? '') || undefined),
    buttonText: '',
    link: '',
    subtitle: `${productsCount} ${t('pluralizeProduct', { count: productsCount })}`,
    mode: banner.entity.banner_data?.theme === 'DARK' ? 'light' : 'dark'
  };
  return result;
};
